import { useMemo } from 'react';
import numeral from 'numeral';
import { getType, getTypeByComparison } from './utils';

interface OHLDataNonStock {
  previous: string;
  change: string | number;
  percentage: string;
  open: string;
  high: string;
  low: string;
  lot: string | number;
  value: string | number;
  average: string;
}

interface ITableOHLNonStock {
  data: OHLDataNonStock;
  isTwoColumn: boolean;
}

const TableOHLNonStock = ({
  data,
  isTwoColumn,
}: ITableOHLNonStock) => {
  const {
    average,
    change,
    high,
    lot,
    low,
    open,
    percentage,
    previous,
    value,
  } = data;
  const classNameTwoColumn = useMemo(
    () => (isTwoColumn ? ' two-column' : ''),
    [isTwoColumn],
  );

  return (
    <table className="table-live-price">
      {isTwoColumn ? (
        <colgroup>
          <col style={{ width: '30px' }} />
          <col style={{ width: '118.5px' }} />
          <col style={{ width: '54px' }} />
          <col style={{ width: '94.5px' }} />
        </colgroup>
      ) : (
        <colgroup>
          <col style={{ width: '30px' }} />
          <col style={{ width: '66.5px' }} />
          <col style={{ width: '42px' }} />
          <col style={{ width: '62px' }} />
          <col style={{ width: '42px' }} />
          <col style={{ width: '54.5px' }} />
        </colgroup>
      )}
      <tbody>
        <tr key="previous-open-lot">
          <td key="previous-title">Prev</td>
          <td key="previous" className={`notchange${classNameTwoColumn}`}>
            {numeral(previous).format('0,0')}
          </td>
          <td key="open-title" className={classNameTwoColumn}>
            Open
          </td>
          <td key="open" className={getTypeByComparison(open, previous)}>
            {open}
          </td>
          {!isTwoColumn && (
          <>
            <td key="lot-title">Lot</td>
            <td key="lot" className={getType(change)}>
              {lot}
            </td>
          </>
          )}
        </tr>
        <tr key="change-high-val">
          <td key="change-title">Chg</td>
          <td
            key="change"
            className={`${getType(change)}${classNameTwoColumn}`}
          >
            {change}
          </td>
          <td key="high-title" className={classNameTwoColumn}>
            High
          </td>
          <td key="high" className={getTypeByComparison(high, previous)}>
            {high}
          </td>
          {!isTwoColumn && (
          <>
            <td key="value-title">Val</td>
            <td key="value" className={getType(change)}>
              {value}
            </td>
          </>
          )}
        </tr>
        <tr key="percentage-change-low-average">
          <td key="percentage-change-title">%</td>
          <td
            key="percentage-change"
            className={`${getType(percentage)}${classNameTwoColumn}`}
          >
            {percentage}
          </td>
          <td key="low-title" className={classNameTwoColumn}>
            Low
          </td>
          <td key="low" className={getTypeByComparison(low, previous)}>
            {low}
          </td>
          {!isTwoColumn && (
          <>
            <td key="average-title">Avg</td>
            <td
              key="average"
              className={getTypeByComparison(average, previous, true)}
            >
              {average}
            </td>
          </>
          )}
        </tr>
      </tbody>
    </table>
  );
};

export default TableOHLNonStock;
